import { FormattedMessage } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";

const DynamicIntranet = () => {
    const localizedHref = useLocalizedHref(
        "/software/confluence/use-cases/intranet-software"
    );
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.dynamicIntranet.content.body"
                    defaultMessage="Customize a dynamic info hub for your entire company with company hub, a single go-to destination for company news, announcements, and resources. <a>Learn more.</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-label-english="learn more"
                                data-track-event="ConfluencePricingPageTeam24.dynamicIntranet.learnMore"
                                data-event-container="ConfluencePriceFinderTeam24"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default DynamicIntranet;
